import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { Link } from 'react-router-dom';

//import tags
import Skeleton from 'react-loading-skeleton';

//import components
import Breadcrumb from './../components/dynamic/Breadcrumb';
import CartItems from '../components/dynamic/cart/CartItems';

//import locales
import { useTranslation } from "react-i18next";
import "../i18n";


//import api
import FetchData from "../api/Api";

export default function Cart() {

    //get context

    const { toCart, setToCart } = useApp();


    //get locale
    const { t } = useTranslation();
    const { locale } = useParams();

    //get data
    const [data, setData] = useState(null);
    const [updatedData, setUpdatedData] = useState(null);
    const [promo, setPromo] = useState(toCart?.promo ? toCart?.promo : '');
    

    useEffect(() => {
        const fetchData = async () => {
            try {
                const fetchDataInstance = new FetchData();
                const result = await fetchDataInstance.action(`/api/cart`, toCart, false);
                
                // Set data only if it's null or needed
                if (data === null) {
                    setData(result);
                }
    
                if (updatedData === null) {
                    setUpdatedData(result);
                }
    
            } catch (error) {
                console.error("Failed to get data:", error.message);
            }
        };
    
        // Fetch data when necessary conditions change
        if (data === null || updatedData === null) {
            setTimeout(function() {
                fetchData();
            }, 200)
            
        }
    
    }, [data, updatedData, toCart]);
    
    useEffect(() => {
        setData(null);
    }, [locale]);
    
    useEffect(() => {
        setUpdatedData(null);
    }, [toCart]);
    
    const activatePromo = () => {
        setToCart((prevCart) => ({
            ...prevCart,
            promo: promo,
        }));
    
        setData(null);
    };
  

    return (
        <>
            <Breadcrumb title={t('cart')} />
            <div className='container mx-auto mt-12'>
                <div className="overflow-x-auto bg-white shadow-lg rounded-lg">
                    <table className="min-w-full table-auto text-left text-sm text-gray-500">
                        <thead className="bg-gray-100 text-gray-700">
                        <tr>
                            <th className="px-6 py-3 font-semibold text-[16px]">{t('product')}</th>
                            <th className="px-6 py-3 font-semibold text-[16px]">{t('price')}</th>
                            <th className="px-6 py-3 font-semibold text-[16px]">{t('amount')}</th>
                            <th className="px-6 py-3 font-semibold text-[16px]">{t('total')}</th>
                            <th className="px-6 py-3 font-semibold text-[16px] text-center">{t('actions')}</th>
                        </tr>
                        </thead>
                        <tbody>
                            {
                                data === null ? 
                                    <tr className="border-b hover:bg-gray-50">
                                        <td className="px-6 py-4">
                                            <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} />
                                        </td>
                                        <td className="px-6 py-4 text-gray-700">
                                            <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} />
                                        </td>
                                        <td className="px-6 py-4 text-gray-700">
                                            <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} />
                                        </td>
                                        <td className="px-6 py-4 text-gray-700">
                                            <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} />
                                        </td>
                                        <td className="px-6 py-4 text-center">
                                            <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} />
                                        </td>
                                    </tr>
                                :

                                (data?.data?.total_quantity === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="text-center py-4 text-gray-500">
                                            Your cart is empty
                                        </td>
                                    </tr>
                                ) : (
                                    data?.data?.products?.map((item) => (
                                        <CartItems key={item.product.id} item={item} setData={setData} data={data} />
                                    ))
                                ))
                            }
                            
                        </tbody>
                    </table>
                    {data?.data?.total_quantity > 0 && (
                        <>
                            
                            <div className='grid grid-cols-6 bg-gray-100'>
                                <div className="col-span-3">
                                    <div className='px-4'>
                                        <input type="text" value={promo} onChange={(e)=>setPromo(e.target.value)} className='px-2 py-1 border rounded-md text-[13px] w-[150px] h-[45px] mt-12 outline-none' placeholder={t('promo_code')} />
                                        <button onClick={activatePromo} className='bg-[var(--orange)] text-white px-2 inline-flex items-center justify-center ms-2 h-[45px] text-[13px] rounded-md hover:shadow-md'>{t('activate')}</button>
                                    </div>
                                </div>
                                <div className='col-span-3'>
                                    <div className="p-4 flex items-end flex-col">
                                        <div className='text-[15px] font-bold mb-2'>{t('total_amount')}: <span className="w-[20px] inline-block text-end">{updatedData?.data?.total_quantity}</span> ც</div>
                                        <div className='text-[15px] font-bold mb-3'>{t('total_price')}: <span className="w-[50px] inline-block text-end">{updatedData?.data?.total_price}</span> ₾ { updatedData?.data?.promo_discount ? <span className="text-red-600 ms-2">(-{updatedData?.data?.promo_discount}₾) </span> : '' }</div>
                                        <Link to={`/${locale}/checkout`} className="bg-[var(--orange)] text-white px-7 py-3 rounded-lg hover:shadow-md">
                                            {t('continue_shopping')}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

